module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/aside_list-705301b4daa4c234922bdc2a8a065725.svg";